'use strict';

var _arraySpeciesCreate = require('./array-species-create');

var _arraySpeciesCreate2 = _interopRequireDefault(_arraySpeciesCreate);

var _flattenIntoArray = require('./flatten-into-array');

var _flattenIntoArray2 = _interopRequireDefault(_flattenIntoArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!Object.prototype.hasOwnProperty.call(Array.prototype, 'flatten')) {

  /**
   * @param {number=Infinity} depth
   */
  Array.prototype.flatten = function flatten(depth) {
    var o = Object(this);
    var a = (0, _arraySpeciesCreate2.default)(o, this.length);
    var depthNum = depth !== undefined ? Number(depth) : Infinity;
    (0, _flattenIntoArray2.default)(a, o, 0, depthNum);
    return a.filter(function (e) {
      return e !== undefined;
    });
  };
}
//# sourceMappingURL=flatten.js.map